import { render, staticRenderFns } from "./NewPmProject.vue?vue&type=template&id=5f06a59b&scoped=true&"
import script from "./NewPmProject.vue?vue&type=script&lang=js&"
export * from "./NewPmProject.vue?vue&type=script&lang=js&"
import style0 from "./NewPmProject.vue?vue&type=style&index=0&id=5f06a59b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06a59b",
  null
  
)

export default component.exports